import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=dbfe27ec&"
import script from "./AssetTable.vue?vue&type=script&lang=ts&"
export * from "./AssetTable.vue?vue&type=script&lang=ts&"
import style0 from "./AssetTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbfe27ec')) {
      api.createRecord('dbfe27ec', component.options)
    } else {
      api.reload('dbfe27ec', component.options)
    }
    module.hot.accept("./AssetTable.vue?vue&type=template&id=dbfe27ec&", function () {
      api.rerender('dbfe27ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/assets/AssetTable.vue"
export default component.exports